<div>
  Product / Billing / Review / Payment / <strong>Confirmation</strong>
</div>
<hr class="hrDiv">
<div class="spinContainer" *ngIf="showSpinner"><mat-spinner></mat-spinner></div>
<div class="pageContainer" *ngIf="!showSpinner">
  <h2 class="gray-clr">Checkout Complete</h2>
  <div [ngClass]="[isSmallView?'leftDiv-ph':'leftDiv']">
    <div class="topDiv">
      <div class="chkoutBanner">
        <mat-icon style="scale:1.5">check</mat-icon><span class="chkoutMsg">Thank you for your AMA Store order.</span>
      </div>
      <h2 class="gray-clr padding-top-10">Order number: {{orderNumber}}</h2>
      <span class="padding-top-10">You will receive an email confirmation shortly at <b>{{userEmail}}</b>.</span>
      <div class="prodDiv">
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="productName">
            <th mat-header-cell *matHeaderCellDef> <b>Product</b>
            </th>
            <td mat-cell *matCellDef="let element"><b>{{element.productName}}</b></td>
          </ng-container>
          <ng-container matColumnDef="price">
            <th mat-header-cell *matHeaderCellDef> <b>Price</b> </th>
            <td mat-cell *matCellDef="let element">{{element.price | currency}} </td>
          </ng-container>
          <ng-container matColumnDef="quantity">
            <th mat-header-cell *matHeaderCellDef> <b>Quantity</b> </th>
            <td mat-cell *matCellDef="let element">{{element.quantity}} </td>
          </ng-container>
          <ng-container matColumnDef="final">
            <th mat-header-cell *matHeaderCellDef> <b>Final</b> </th>
            <td mat-cell *matCellDef="let element"> {{element.final | currency}}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
          <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
        </table>
      </div>
      <div class="botSectionDiv">
        <div class="addressDiv">
          <b>Billing Address:</b><br>
          <span>{{billingAddr.name}}<br></span>
          <span>{{billingAddr.field1}}<br></span>
          <span *ngIf="billingAddr.field2">{{billingAddr.field2}}<br></span> 
          <span *ngIf="billingAddr.field3">{{billingAddr.field3}}<br></span> 
          <span>{{billingAddr.cityStateZip}} <br></span>
          <span>{{userEmail}}</span>

        </div>
        <div class="paymentDiv">
          <b>Payment:</b><br>
          <div *ngIf="cardDtls.method && cardDtls.method==='CreditCard'">
            <div [ngClass]="'cardIcon ' + cardDtls.cardType"></div>
            <span class="padding-left-10">****{{cardDtls.endingNbr}} exp. {{cardDtls.month}}/{{cardDtls.year}}</span>
          </div>
          <div *ngIf="cardDtls.method && cardDtls.method!='CreditCard'">
            {{cardDtls.method}}
          </div>
        </div>
      </div>
    </div>

  </div>
  <div [ngClass]="[isSmallView?'rightDiv-ph':'rightDiv']">
    <mat-card class="mat-card sm">
      <mat-card-content>
        <div>
          <span class="purple-clr"><h2>Order Summary</h2></span>
          <div>
            <div class="itemDiv" *ngFor="let product of prodList"> 
              <div class="itemSpan"> 
                <b>{{product.productName}}</b> <br>
                Term: {{getTerm(product.term)}}
              </div>
              <div class="qntySpan">
                <mat-label class="qntyLbl">Quantity:</mat-label>{{product.quantity}} 
              </div>
            </div>
            <table class="prTable">
              <tr>
                <td>Sub Total:</td>
                <td class="flRght">{{orderSummaryDtls.subTotal | currency}}</td>
              </tr>
              <tr *ngIf="orderSummaryDtls.promoDiscount && orderSummaryDtls.promoDiscount > 0">
                <td>Promo Discount:</td>
                <td class="flRght">-{{orderSummaryDtls.promoDiscount | currency}}</td>
              </tr>
              <tr>
                <td>Tax:</td>
                <td class="flRght">{{orderSummaryDtls.tax | currency}}</td>
              </tr>
              <tr>
                <td>Total:</td>
                <td class="flRght">{{orderSummaryDtls.orderTotal | currency}}</td>
              </tr>
            </table> 
          </div>
        </div><br>
      </mat-card-content>      
    </mat-card><br><br> 
    <mat-card class="mat-card sm">
      <mat-card-content>
        <div>
          <span class="purple-clr"><h2 class="cardTitle">Manage RBRVS DataManager Users</h2></span>
        </div><br>
        <div>As a purchaser you can designate user(s) as secondary administrators to manage license seats, and or designate user(s) for product licenses purchased.</div><br>
        <div><button mat-fab extended class="btn-cls" [routerLink]="['/manage-admins']">Manage RBRVS DataManager Users</button></div>
      </mat-card-content>  
    </mat-card>
  </div>
</div>